import { apiRequest } from "../util/apiUtils";

const run = async (payload) => {
  const res = await apiRequest("post", `runpod/run`, {
    body: payload,
  });

  return res?.data;
}

export { run }